/**
 * @file Helper function for the compose form, that are used in multiple places
 */

import translate from '../../i18n/translate';

/**
 * Get Send button label based on usage and mode
 *
 * @param isEditMode Whether Editor is in template edit mode
 * @returns          Translation key
 */
export const getLabelConfirm = (isEditMode: boolean) => {
  return translate(isEditMode ? 'GENERAL__EDIT' : 'GENERAL__CREATE');
};
